import React from "react";
import { Link } from "react-router-dom";

const InformacionTercero = ({ terceroSelected }) => {
    return (
        <div className="row mt-2px">
            <div className="invoice-from">
                <small>Datos del tercero</small>
                <address className="mt-2px mb-5px">
                    <Link to={"/tercero/" + terceroSelected?.id} className=" text-dark fw-bold">
                        <strong>{terceroSelected?.razonsocial}</strong>
                    </Link>
                    <br />
                    <strong className="text-dark">Direccion:</strong> {terceroSelected?.direccion}
                    <br />
                    <strong className="text-dark">Registro:</strong> {terceroSelected?.registro}
                    <br />
                    <strong className="text-dark">NIT:</strong> {terceroSelected?.nit}
                    <br />
                    <strong className="text-dark">Giro:</strong> {terceroSelected?.giro}
                    <br />
                </address>
            </div>
        </div>
    );
};

export default InformacionTercero;
